import { trackForwardedComponent } from '../../util/trackComponent.js';
export { BaseChip } from './BaseChip.js';
import { Chip as ChipMemoized } from './Chip.js';
import { FilterChip as FilterChipMemoized } from './FilterChip.js';
import './Chip.types.js';

var ChipWithTracking = trackForwardedComponent(ChipMemoized);
var FilterChipWithTracking = trackForwardedComponent(FilterChipMemoized);

export { ChipWithTracking as Chip, FilterChipWithTracking as FilterChip };
//# sourceMappingURL=external.js.map
